import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { SiteusermappingService } from '../../Model/SiteUserMapping/siteusermapping.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import * as XLSX from 'xlsx';

interface User {
  SiteMasterID: number;
  SiteName: string;
}
@Component({
  selector: 'app-site-user-rights',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, LoaderComponent],
  templateUrl: './site-user-rights.component.html',
  styleUrl: './site-user-rights.component.scss'
})
export class SiteUserRightsComponent {
  searchTerm: string = '';
  @ViewChild('siteSelect') siteSelect!: ElementRef;

  ExcelHeaders = ['SiteCode', 'SiteName'];
  excelcheck = false;
  isDisabled: boolean = false;
  BranchMaster: any[] = [];
  ClientLoad: any[] = [];
  UserMaster: any[] = [];

  Site: any[] = [];
  UserAssignedSite: any[] = [];

  selectedSiteIds: number[] = [];
  selectedassignedSitesIds: number[] = [];

  BranchId: any = null;
  ClientId: any = null;
  UserId: any = null;
  public User: any = null;

  AllClient: boolean = false;
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private download: DownloadSampleService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private siteusermapping: SiteusermappingService
  ) {
    this.User = this.sessionService.GetUserDetails();
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.ComboLoad('UserMaster');
    this.common.CheckExpiry();
    //this.ComboLoad('Branch');
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'ClientUserRight') ? this.BranchId : 0,
      'UserWiseBranchId': (Combotype == 'BranchUserRight' || Combotype == 'ClientUserRight') ? this.UserId : 0,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'BranchUserRight') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'ClientUserRight') {
          this.ClientLoad = response.ComboLoad;
        } else if (Combotype == 'UserMaster') {
          this.UserMaster = response.ComboLoad;
        }
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
      },
    });
  }

  Load() {
    if (this.UserId === '' || this.UserId === null) {
      this.toast.show({ message: 'Please select User!', type: toastTypeEnum.warning });
      return
    }
    this.isDisabled = true;
    this.siteusermapping.ESS_UserWiseSiteRightsSelect({ SelectType: 'S', UserMasterId: this.UserId, BranchId: this.BranchId, ClientId: this.ClientId }).subscribe({
      next: (response) => {
        this.UserAssignedSite = response.Table;
        if (this.UserAssignedSite.length > 0) {
          this.AllClient = this.UserAssignedSite[0].AllClientAccess == 1 ? true : false;
        }
        else {
          this.AllClient = false;
        }
        if(response.Table1 && response.Table1.length > 0){
          this.Site = response.Table1;
        }else{
          this.Site = [];
        }
        
        this.isDisabled = false;
        this.searchTerm = ''
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error: any) => {
        console.log(error);
        this.isDisabled = false;
      },
    });
  }

  transferSites(source: User[], target: User[], selectedIds: number[]) {
    const selectedSites = source.filter(user => selectedIds.includes(user.SiteMasterID));
    target.push(...selectedSites);
    return source.filter(user => !selectedIds.includes(user.SiteMasterID));
  }

  onSiteClick(type: string) {
    if (type === 'siteToAssign') {
      this.Site = this.transferSites(this.Site, this.UserAssignedSite, this.selectedSiteIds);
      this.selectedSiteIds = [];
    }
    else if (type === 'assignToSite') {
      this.UserAssignedSite = this.transferSites(this.UserAssignedSite, this.Site, this.selectedassignedSitesIds);
      this.selectedassignedSitesIds = [];
    }
    // else if (type === 'siteToAssignAll') {
    //   this.UserAssignedSite.push(...this.Site);
    //   this.Site = [];
    // }
    // else if (type === 'assignToSiteAll') {
    //   this.Site.push(...this.UserAssignedSite);
    //   this.UserAssignedSite = [];
    // }
    else if (type === 'siteToAssignAll') {
      this.UserAssignedSite = this.UserAssignedSite.concat(this.Site);
      this.Site = [];
    }
    else if (type === 'assignToSiteAll') {
      this.Site = this.Site.concat(this.UserAssignedSite);
      this.UserAssignedSite = [];
    }
    this.searchTerm = ''
  }

  highlightAndScroll() {
    if (this.searchTerm !== '') {
      const matchingUsers = this.Site.filter(user =>
        user.SiteName.toLowerCase().includes(this.searchTerm.toLowerCase())
        || 
        user.SiteCode.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
      if (matchingUsers.length > 0) {
        this.selectedSiteIds = matchingUsers.map(user => user.SiteMasterID);

        const firstMatchIndex = this.Site.findIndex(user =>
          user.SiteMasterID === matchingUsers[0].SiteMasterID
        );
        setTimeout(() => {
          const optionElements = this.siteSelect.nativeElement.options;

          if (optionElements[firstMatchIndex]) {
            optionElements[firstMatchIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        }, 0);
      }
    }
  }

  async save() {
    await this.common.getPageRights();
    // if (this.UserAssignedSite.length <= 0 && !this.AllClient) {
    //   this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
    //   return
    // }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to save?'
    modalRef.result.then((result: any) => {
      if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
        if (result) {
          this.InsertUpdate();
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {

    });
  }
  InsertUpdate() {
    const Data = {
      SelectType: 'I',
      UserMasterId: this.UserId,
      SiteId: this.AllClient ? 0 : this.UserAssignedSite.map(item => item.SiteMasterID).join(', '),
      UserId: this.User.UserId
    };

    this.siteusermapping.ESS_UserWiseSiteRightsInsertUpdate(Data).subscribe(
      data => {
        if (data.Error_Code == '454') {
          this.isDisabled = false
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              //this.Load();
              this.Site = [];
              this.UserAssignedSite = [];
              this.AllClient = false;
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
      },
      error => {
        console.error('Error:', error);
      });
  }
  Reset() {
    window.location.reload();
  }
  onChange(type: string) {
    if (type === 'Branch') {
      this.ClientLoad = [];
      this.ClientId = null;
    }
    else if (type === 'User') {
      this.BranchId = null;
      this.BranchMaster = [];
      this.ClientLoad = [];
      this.ClientId = null;
    }
  }

  async ExportExcel() {
    let excelData = [];
    console.log(this.Site);
    if (this.Site.length > 0) {
      try {
        this.isDisabled = true;
        await new Promise(f => setTimeout(f, 500));

        excelData = JSON.parse(JSON.stringify(this.Site));
        excelData.forEach(function (x: any) {
          delete x.BranchCode, delete x.BranchMasterID, delete x.BranchName
            , delete x.ClientGroupMasterID, delete x.ClientGroupName, delete x.ESS_UserWiseSiteRightsId, delete x.Name, delete x.UserMasterId,
            delete x.SiteMasterID
        });
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'ExcelSheet.xlsx');
        this.isDisabled = false;
      } catch (e) {
        this.isDisabled = false;
      }
    }
  }

  handleFileInputChange(event: any): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const fileType: string | undefined = file.name.split('.').pop();
      if (fileType !== 'xlsx' && fileType !== 'xls') {
        this.toast.show({ message: 'Please select an Excel file only.', type: toastTypeEnum.danger });
        return;
      }
      this.processExcelFile(file);

      input.value = '';
    } else {
      console.log('No file selected or file selection cancelled');
    }
  }

  processExcelFile(file: File): void {
    this.excelcheck = true;
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event && event.target && event.target.result) {
        const binaryString = event.target.result as string;
        const workbook = XLSX.read(binaryString, { type: 'binary' });
        const sheetName = 'Sheet1';
        if (!workbook.SheetNames.includes(sheetName)) {
          const errorMessage = 'Sheet1 not found in the uploaded file.';
          this.toast.show({ message: errorMessage, type: toastTypeEnum.danger });
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }) as any[][];
        if (excelData.length > 1) {
          const headerRow = excelData[0];
          const headers = headerRow.map((header: string) => header.trim());

          this.ExcelHeaders.forEach(element => {
            if (this.excelcheck) {
              if (headers.findIndex(e => this.common.ToLowerCase(e) == this.common.ToLowerCase(element)) >= 0) {
                this.excelcheck = true;
              } else {
                this.excelcheck = false;
              }
            }

            if (!this.excelcheck) {
              return;
            }
          });

          if (!this.excelcheck) {
            const modalRef = this.modalService.open(AlertWarningComponent, {
              size: 'md',
              backdrop: 'static',
              centered: true,
              windowClass: 'confirmation-modal'
            });
            modalRef.componentInstance.Message = "Excel file column not match. please check sample file";
            modalRef.result.then((result: any) => { });
          } else {
            const dataRows = excelData.slice(1).map(e => e.length > 0 ? e : null).filter(e => e != null);

            for (let rowIndex = 0; rowIndex < dataRows.length; rowIndex++) {
              const row = dataRows[rowIndex] ?? [];
              const rowData: any = {};

              row.forEach((cellData, index) => {
                rowData[headers[index]] = cellData;
              });

              if (this.Site.findIndex(e => e.SiteCode == rowData.SiteCode) >= 0) {
                this.selectedSiteIds.push(this.Site[this.Site.findIndex(e => e.SiteCode == rowData.SiteCode)].SiteMasterID);
              }
            }
            this.onSiteClick('siteToAssign');
          }
        } else {

          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = "Excel file have a no data";
          modalRef.result.then((result: any) => { });
        }
      } else {
        console.error('Failed to read the file.');
      }
    };
    reader.readAsBinaryString(file);
  }

  clear(){
    this.Site = [];
    this.UserAssignedSite = [];
    this.selectedSiteIds = [];
    this.selectedassignedSitesIds = [];
  }
}
